import Vue from 'vue';
import { gsap, ScrollTrigger } from 'gsap/all';
import Errors from '../classes/Errors';

Vue.component('list-scroll-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.initRevealItem();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initRevealItem() {
            const elements = [
                ...document.querySelectorAll('li.list-scroll__list-item'),
            ];

            elements.forEach((element) => {
                const { revealDelay, revealManually, revealPosition } = element.dataset;
                if (revealManually === '') {
                    return;
                }

                if (revealPosition) {
                    // console.log(revealPosition);
                }

                const startPercentage = revealPosition || '75%';

                ScrollTrigger.create({
                    trigger: element,
                    start: `top ${startPercentage}`,
                    onEnter: () => {
                        if (!revealDelay) {
                            element.classList.add('list-scroll__list-item--active');
                            return;
                        }

                        gsap.delayedCall(revealDelay, () => {
                            element.classList.add('list-scroll__list-item--active');
                        });
                    },
                });
            });
        },
    },
});
